import type { AutocompleteProps } from "@heroui/autocomplete";
import {
	BOARDS_KEY_MAPPER_ENUM,
	CAMPAIGNS_COLUMNS,
} from "@onesolution/constants";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import { getItemPageByValuesFromServer } from "@onesolution/serverFn";

export default function CampaignsSelector(
	props: {
		name: string;
		form: AppFormApi;
	} & Omit<AutocompleteProps, "children" | "form">,
) {
	const { t } = useLanguage();
	const { form, name, ...restProps } = props;

	const campaigns = getItemPageByValuesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.campaigns,
		columnIds: [CAMPAIGNS_COLUMNS.name],
		filter: [],
	});

	return (
		<form.AppField name={name}>
			{(field) => (
				<field.Autocomplete
					label={t("name.campaigns")}
					placeholder={t("name.campaigns")}
					defaultItems={campaigns.data}
					isLoading={campaigns.isLoading}
					{...restProps}
				/>
			)}
		</form.AppField>
	);
}
